import { OrganizationDto } from "./OrganizationDto";
import { PriceDto } from "./PriceDto";
import { StyleDto, StyleViewDto } from "./StyleDto";
import { ImageRefDto, LogoDto, ProductRefDto } from "./LogoDto";
import { ApprovalGroupDto } from "./ApprovalDto";
import { DesignStatus } from "../../../core/models/entities/enums/DesignStatus";
import { ApprovalType } from "../../../core/models/entities/BaseLogo";

export interface DesignDto {
  id: number;
  updateAtUtc: string;
  createdAtUtc: string;
  createdBy: string;
  status: DesignStatus;
  designLogos: DesignLogoDto[];
  approval: ApprovalGroupDto;
  approvalType: ApprovalType;
  displayImage: ImageRefDto;
  customerId: number;
  customer: OrganizationDto;
  mainOrganizationId?: number;
  style: StyleDto;
  styleId: number;
  title: string;
  product: MultiProductRefDto;
  heating: HeatingProductRefDto;
  viewImages?: StyleViewDto[];
  vendorLogoUrl?: string;
  measurementLines?: DesignMeasurementLineDto[];
  isEditable?: boolean;
  navManufacturerName?: string;
  navStyleName?: string;
  priceSort?: number;
  note?: string;
}

export interface MultiProductRefDto {
  mul: string;
  products: ProductRefDto[];
  totalPrices: PriceDto[];
}

export interface HeatingProductRefDto {
  name: string;
  sku: string;
  prices: PriceDto[];
}

export interface DesignLogoDto {
  id: number;
  logoId: number;
  inDesignId: string;
  action: EditAction | null;
  logo: LogoDto;
  logoX: number;
  logoY: number;
  createdAtUtc: string;
  updateAtUtc: string;
  createdBy: string;
  angleRads: number;
  heightMm: number;
  widthMm: number;
  designerWidthMm: number;
  viewId: number;
  viewName: string;
  alternativeText?: string;
  alternativeTextImageUri?: string;
}

export enum EditAction {
  Move,
  Resize,
}

export interface DesignMeasurementLineDto {
  id: number;
  viewId: number;
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  label: string;
  color: string;
}
